<template>
  <div>
    <table width="718" border="0" cellspacing="0" cellpadding="0" v-if="document()">
<!--    <table width="718" border="0" cellspacing="0" cellpadding="0">-->
      <tr style="height: 1px"><td width="57"/><td width="38"/><td width="129"/><td width="68"/><td width="49"/><td width="19"/><td width="57"/><td width="38"/><td width="129"/><td width="68"/><td width="49"/><td width="19"/></tr>
      <tr style="height:18px">
        <td colspan="12" class="s0">Акт сверки</td>
      </tr>
      <tr style="height:44px">
        <td colspan="12" class="s1">взаимных расчетов за период с 01.01.2022 по 31.12.2022<br>между ТОО &quot;BTcom infocommunications&quot; и {{document().contragent.contragent_prefix}} {{document().contragent.name}} (л/сч {{document().account_id}}) по договору {{document().contract.countract_num}} от {{document().contract.contract_date}}</td>
      </tr>
      <tr style="height:29px">
        <td colspan="12" rowspan="2" class="s2">Мы, нижеподписавшиеся, __________________ ТОО &quot;BTcom infocommunications&quot; ________________, с одной стороны, и ____________________ {{document().contragent.contragent_prefix}} {{document().contragent.name}} _______________________, с другой стороны, составили настоящий акт сверки о том, что состояние взаимных расчетов по данным учета следующее:</td>
      </tr>
      <tr style="height:7px">

      </tr>
      <tr style="height:18px">
        <td colspan="6" class="s3">По данным ТОО &quot;BTcom infocommunications&quot;, KZT</td><td colspan="6" class="s20">По данным {{document().contragent.contragent_prefix}} {{document().contragent.name}}, KZT</td>
      </tr>
      <tr style="height:15px">
        <td class="s21">Дата</td><td colspan="2" class="s22">Документ</td><td class="s22">Дебет</td><td colspan="2" class="s22">Кредит</td><td class="s22">Дата</td><td colspan="2" class="s22">Документ</td><td class="s22">Дебет</td><td colspan="2" class="s22">Кредит</td>
      </tr>

      <template v-for="(item, index) in document_content()">
        <tr style="height:15px" v-if="item.order_index === 0" :key="index +'_0'">
          <td colspan="3" class="s23">{{ item.event_text }}</td><td class="s24">{{ item.company_debit }}</td><td colspan="2" class="s25">{{ item.company_credit }}</td><td colspan="3" class="s26">Сальдо на дату 1 января 2022 г.</td><td class="s25">{{ item.contragent_debit }}</td><td colspan="2" class="s24">{{ item.contragent_credit }}</td>
        </tr>

        <tr style="height:21px" v-if="item.order_index === 1" :key="index +'_1'">
          <td class="s27">{{ item.event_date }}</td><td colspan="2" class="s28">{{ item.event_text }}</td><td class="s25">{{ item.company_debit }}</td><td colspan="2" class="s29">{{ item.company_credit }}</td><td class="s22">{{ item.event_date }}</td><td colspan="2" class="s30">{{ item.event_text }}</td><td class="s29">{{ item.contragent_debit }}</td><td colspan="2" class="s25">{{ item.contragent_credit }}</td>
        </tr>

        <tr style="height:15px" v-if="item.order_index === 3" :key="index +'_3'">
          <td colspan="3" class="s23">{{ item.event_text }}</td><td class="s24">13 379.81</td><td colspan="2" class="s25">0.00</td><td colspan="3" class="s26">Сальдо на конец 31 декабря 2022 г.</td><td class="s25">0.00</td><td colspan="2" class="s24">13 379.81</td>
        </tr>
      </template>

      <tr style="height:4px">
        <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>

      <tr style="height:18px">
        <td colspan="12" class="s14">По данным ТОО &quot;BTcom infocommunications&quot;</td>
      </tr>
      <tr style="height:15px">
        <td colspan="12" class="s12">на 31.12.2022 задолженность в пользу ТОО &quot;BTcom infocommunications&quot;</td>
      </tr>
      <tr style="height:1px">
        <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:18px">
        <td colspan="12" class="s15"> 13 379.81 KZT</td>
      </tr>
      <tr style="height:6px">
        <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:29px">
        <td colspan="6" class="s13">От ТОО &quot;BTcom infocommunications&quot;</td><td colspan="6" class="s13">От ТОО &quot;SKA 63&quot;</td>
      </tr>
      <tr style="height:1px">
        <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:18px">
        <td colspan="5" class="s13">Генеральный директор</td><td/><td colspan="5" class="s13">Директор</td><td/>
      </tr>
      <tr style="height:7px">
        <td colspan="5" rowspan="2" class="s13">Муканова С.Г.</td><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:12px">
        <td/><td colspan="5" rowspan="2" class="s16" style="font-size:1px">&nbsp;</td><td/>
      </tr>
      <tr style="height:7px">
        <td colspan="5" class="s19" style="font-size:1px">&nbsp;</td><td/><td/>
      </tr>
      <tr style="height:4px">
        <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:18px">
        <td colspan="5" class="s13">Главный бухгалтер</td><td/><td colspan="5" class="s13">Главный бухгалтер</td><td/>
      </tr>
      <tr style="height:7px">
        <td colspan="5" rowspan="2" class="s13">Кульбаева Р.Ж.</td><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:12px">
      <td/><td colspan="5" rowspan="2" class="s16" style="font-size:1px">&nbsp;</td><td/>
      </tr>
      <tr style="height:7px">
        <td colspan="5" class="s16" style="font-size:1px">&nbsp;</td><td/><td/>
      </tr>
      <tr style="height:6px">
        <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:18px">
        <td colspan="5" class="s13">Исполнитель</td><td/><td colspan="5" class="s13">Исполнитель</td><td/>
      </tr>
      <tr style="height:1px">
        <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:7px">
        <td colspan="5" rowspan="2" class="s13">Оразбаева А.Н.</td><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:11px">
        <td/><td colspan="5" rowspan="2" class="s16" style="font-size:1px">&nbsp;</td><td/>
      </tr>
      <tr style="height:7px">
        <td colspan="5" class="s19" style="font-size:1px">&nbsp;</td><td/><td/>
      </tr>
      <tr style="height:10px">
        <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:18px">
        <td colspan="2" class="s17">М. П.</td><td/><td/><td/><td/><td colspan="2" class="s17">М. П.</td><td/><td/><td/><td/>
      </tr>
      <tr style="height:52px">
        <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:26px">
        <td colspan="12" class="s18"><i>Подписанные акты необходимо вернуть на электронную почту по адресу : </i><i><b> sales-9@btcom.kz </b></i><i><br>Рабочие телефоны: </i><i><b>+7 (701) 082 42 07; +7 (727) 2777 790; +7 (727) 2777 888 (вн. 7207) </b></i><i> </i></td>
      </tr>
      <tr style="height:15px">
        <td colspan="12" class="s18">03.03.2023 9:17:52</td>
      </tr>
      </table>
  </div>
</template>

<script>
export default {
  name: "ActReconciliation",
  methods:{
    currentDate: function (){
      const current = new Date();
      // const output = `${current.getDate()}.${current.getMonth()}.${current.getFullYear()} ${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
      const output = current.toLocaleString();
      return output;
    },
    document: function (){
      return this.$store.state.current_document ? this.$store.state.current_document : null
    },
    document_content: function (){
      return this.$store.state.current_document_content ? this.$store.state.current_document_content : null
    },
    total_amount(){
      const init = 0
      let tot = 0
      if (this.document_content()){
         tot = this.document_content().reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue.final_amount), init
        )
      }
      return tot
    },
    total_quantity(){
      const init = 0
      let tot = 0
      if (this.document_content()){
         tot = this.document_content().reduce(
            (accumulator, currentValue) => accumulator + Number(currentValue.quantity), init
        )
      }
      return tot
    },
  },
}
</script>

<style scoped>

.page_break {page-break-before: always;}

.s0 {
 font-family: Arial;
 font-size: 16px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 text-align: Center; vertical-align: Top;
 padding-top: 1px;
}

.s1 {
 font-family: Arial;
 font-size: 11px;
 color: #000000; font-style: normal;
 background-color: transparent;
 text-align: Center; vertical-align: Top;
 padding-top: 1px;
}

.s2 {
 font-family: Arial;
 font-size: 9px;
 color: #000000; font-style: normal;
 background-color: transparent;
 text-align: Justify; vertical-align: Top;
 padding-top: 1px;
 padding-left: 2px;
 padding-right: 2px;
}

.s3 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Center; vertical-align: Middle;
}

.s4 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

.s5 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Right; vertical-align: Middle;
 padding-right: 2px;
}

.s6 {
 font-family: Arial;
 font-size: 11px;
 color: #FFFFFF; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Right; vertical-align: Middle;
 padding-right: 2px;
}

.s7 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

.s8 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

.s9 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Right; vertical-align: Middle;
 padding-right: 2px;
}

.s10 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Center; vertical-align: Middle;
}

.s11 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

.s12 {
 font-family: Arial;
 font-size: 11px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 text-align: Left; vertical-align: Top;
 padding-top: 1px;
 padding-left: 2px;
}

.s13 {
 font-family: Arial;
 font-size: 9px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 text-align: Left; vertical-align: Top;
 padding-top: 1px;
 padding-left: 2px;
}

.s14 {
 font-family: Arial;
 font-size: 11px;
 color: #000000; font-style: normal;
 background-color: transparent;
 text-align: Left; vertical-align: Top;
 padding-top: 1px;
 padding-left: 2px;
}

.s15 {
 font-family: Arial;
 font-size: 11px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

.s16 {
 font-family: Arial;
 font-size: 9px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-width: 0px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Left; vertical-align: Top;
 padding-top: 1px;
 padding-left: 2px;
}

.s17 {
 font-family: Arial;
 font-size: 9px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

.s18 {
 font-family: Arial;
 font-size: 9px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-width: 0px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-width: 0px;
 text-align: Left; vertical-align: Top;
 padding-top: 1px;
 padding-left: 2px;
}

.s19 {
 font-family: Arial;
 font-size: 9px;
 color: #000000; font-style: normal;
 background-color: transparent;
 text-align: Left; vertical-align: Top;
 padding-top: 1px;
 padding-left: 2px;
}

.s20 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Center; vertical-align: Middle;
}

.s21 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Center; vertical-align: Middle;
}

.s22 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Center; vertical-align: Middle;
}

.s23 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

.s24 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Right; vertical-align: Middle;
 padding-right: 2px;
}

.s25 {
 font-family: Arial;
 font-size: 11px;
 color: #FFFFFF; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Right; vertical-align: Middle;
 padding-right: 2px;
}

.s26 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-weight: bold; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

.s27 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Center; vertical-align: Middle;
}

.s28 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

.s29 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Right; vertical-align: Middle;
 padding-right: 2px;
}

.s30 {
 font-family: Arial;
 font-size: 8px;
 color: #000000; font-style: normal;
 background-color: transparent;
 border-left-width: 0px;
 border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
 border-top-width: 0px;
 border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
 text-align: Left; vertical-align: Middle;
 padding-left: 2px;
}

P {margin: 0;}

</style>